import { render, staticRenderFns } from "./issueTask.vue?vue&type=template&id=46924822&scoped=true&"
import script from "./issueTask.vue?vue&type=script&lang=js&"
export * from "./issueTask.vue?vue&type=script&lang=js&"
import style0 from "./issueTask.vue?vue&type=style&index=0&id=46924822&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46924822",
  null
  
)

export default component.exports